const consoleMethodLevels = {
    debug: 0,
    log: 1,
    info: 2,
    warn: 3,
    error: 4
};

const readLogTypeFromEnv = () => {
    if (typeof process !== 'undefined' && process.env !== undefined && process.env !== null) {
        if (process.env.LogType !== undefined && process.env.LogType !== null && String(process.env.LogType).trim() !== '') {
            return String(process.env.LogType).trim();
        }
        if (process.env.VUE_APP_LogType !== undefined && process.env.VUE_APP_LogType !== null && String(process.env.VUE_APP_LogType).trim() !== '') {
            return String(process.env.VUE_APP_LogType).trim();
        }
    }
    return 'Important';
};

const getLogType = () => readLogTypeFromEnv();

const getLogLevel = () => {
    const logType = getLogType();
    if (logType === 'All') return 'debug';
    if (logType === 'Important') return 'warn';
    return 'info';
};

const getMinimumConsoleLevel = () => {
    const logType = getLogType();
    if (logType === 'All') {
        return 0;
    }
    if (logType === 'Important') {
        return 3;
    }
    return 2;
};

const shouldAllowConsoleMethod = (method) => {
    const methodLevel = consoleMethodLevels[method];
    if (methodLevel === undefined || methodLevel === null) {
        return true;
    }
    return methodLevel >= getMinimumConsoleLevel();
};

const resolvedLogLevel = getLogLevel();

function installConsoleGuard() {
    if (typeof globalThis !== 'undefined' && globalThis.__frontendLogConsoleGuardInstalled === true) {
        return;
    }
    if (typeof globalThis !== 'undefined') {
        globalThis.__frontendLogConsoleGuardInstalled = true;
    }
    const methods = ['log', 'info', 'warn', 'error', 'debug'];
    for (let index = 0; index < methods.length; index = index + 1) {
        const method = methods[index];
        const originalMethod = console[method];
        if (typeof originalMethod === 'function') {
            console[method] = (...args) => {
                if (shouldAllowConsoleMethod(method) === false) {
                    return;
                }
                return originalMethod.apply(console, args);
            };
        }
    }
}

installConsoleGuard();

class SmartLogger {
    constructor() {
        this.level = resolvedLogLevel;
        this.levels = {
            'debug': 0,
            'info': 1,
            'warn': 2,
            'error': 3
        };
    }

    shouldLog(level) {
        return this.levels[level] >= this.levels[this.level];
    }

    debug(message, metadata = {}) {
        if (this.shouldLog('debug') === true) {
            console.debug(`[DEBUG] ${message}`, metadata);
        }
    }

    info(message, metadata = {}) {
        if (this.shouldLog('info') === true) {
            console.info(`[INFO] ${message}`, metadata);
        }
    }

    warn(message, metadata = {}) {
        if (this.shouldLog('warn') === true) {
            console.warn(`[WARN] ${message}`, metadata);
        }
    }

    error(message, error = null, metadata = {}) {
        if (this.shouldLog('error') === true) {
            let errorMeta = metadata;
            if (error !== undefined && error !== null) {
                if (error instanceof Error) {
                    errorMeta = { errorMessage: error.message, stack: error.stack, ...metadata };
                } else {
                    errorMeta = { errorMessage: String(error), ...metadata };
                }
            }
            console.error(`[ERROR] ${message}`, errorMeta);
        }
    }

    getLevel() {
        return this.level;
    }

    isDebugEnabled() {
        return this.level === 'debug';
    }
}

const smartLoggerInstance = new SmartLogger();

export function getLogger(filenameOrModule) {
    let fileName = '';
    if (typeof filenameOrModule === 'string') {
        fileName = filenameOrModule.split('/').pop().split('\\').pop();
    } else if (filenameOrModule && filenameOrModule.filename) {
        fileName = filenameOrModule.filename.split('/').pop().split('\\').pop();
    }

    return {
        info: (funcName, msg) => smartLoggerInstance.info(`${fileName}:${funcName} ${msg}`),
        warn: (funcName, msg) => smartLoggerInstance.warn(`${fileName}:${funcName} ${msg}`),
        error: (funcName, msg, error = null) => smartLoggerInstance.error(`${fileName}:${funcName} ${msg}`, error),
        debug: (funcName, msg) => smartLoggerInstance.debug(`${fileName}:${funcName} ${msg}`),
    };
}

export default smartLoggerInstance;
